import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const ERC = () => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageWrapper>
          <StyledImage
            src={messages['home.erc.image.src']}
            alt={messages['home.erc.image.alt']}
          />
        </ImageWrapper>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id="home.erc.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.erc.paragraph" />
          </Subtitle>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default ERC;
